import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

//Material UI Imports
import { Avatar, Box, Card, CardContent, Chip, Grid, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import { DataGrid } from '@mui/x-data-grid';
import StatCard from '../../../components/StatCard';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import KeyIcon from '@mui/icons-material/Key';
import PersonIcon from '@mui/icons-material/Person';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import { useSelector } from 'react-redux';
import PageHeader from '../../../components/common/PageHeader';

const O365Dashboard = () => {

    const [filteredO365Licenses, setFilteredO365Licenses] = useState([]);
    const [filteredO365Users, setFilteredO365Users] = useState([]);
    const { data: o365Licenses = [], loadingLicense, errorLicense } = useSelector((state) => state.o365.licenses);
    const { data: o365Users = [], loadingUser, errorUser } = useSelector((state) => state.o365.users);



  const [history, setHistory] = useState([]);
//   const [o365Licenses, seto365Licenses] = useState([]);
//   const [o365Users, seto365Users] = useState([]);
//   const [loadingLicense, setloadingLicense] = useState(false);
//   const [loadingUser, setLoadingUser] = useState(false);
    const { selectedOrganization } = useOrganizationSelect();
  

      
      const fetchHistory = async () => {
          try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/history`);
              setHistory(
                  response.data
                      .filter((o365) => o365.entity === "o365")
                      .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              );
          } catch (error) {
              console.error('Error fetching organizations:', error);
          }
      };
    
      
    useEffect(() => {
        fetchHistory();

        if (selectedOrganization) {
            setFilteredO365Licenses(o365Licenses.filter(
                (item) => item.organizationName === selectedOrganization
            ));
              setFilteredO365Users(o365Users.filter(
                (item) => item.organizationName === selectedOrganization
            ));
        } else {
            setFilteredO365Licenses(o365Licenses);
            setFilteredO365Users(o365Users);
        }
    }, [selectedOrganization, filteredO365Licenses, filteredO365Users]);


// Calculate number of licenses expiring in less than 30 days
const expiringSoonCount = filteredO365Licenses.filter(license => {
    if (!license.nextCycleDateTime) return false;
    const expDate = new Date(license.nextCycleDateTime);
    const now = new Date();
    const diffDays = (expDate - now) / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= 30;
}).length;


    // const columnsFilteredOverusedLicenses = useMemo(
    //   () => [
    //     {
    //       id: 'licensesOverused', //id used to define `group` column
    //       columns: [
    //         {
    //           accessorFn: (row) => `${row.licenseName}`, //accessorFn used to join multiple data into a single cell
    //           id: 'name', //id is still required when using accessorFn instead of accessorKey
    //           header: 'Nom',
    //           size: 40,
    //           Cell: ({ renderedCellValue, row }) => (
    //             <Box
    //               sx={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 gap: '1rem',
    //               }}
    //             >{renderedCellValue}
    //             </Box>
    //           ),
    //           filterVariant: 'multi-select',
    //         },
    //         {
    //             accessorKey: 'used', //hey a simple column for once
    //             header: 'Utilisé',
    //             size: 40,
    //         },
    //         {
    //             accessorKey: 'total', //hey a simple column for once
    //             header: 'Total',
    //             size: 40,
    //         },
    //         {
    //             accessorKey: 'organizationName', //hey a simple column for once
    //             header: 'Client',
    //             filterVariant: 'autocomplete',
    //         },




    //       ]}
    //   ],
    //   [],
    // );
    
  
    // const tableFilteredOverusedLicenses = useMaterialReactTable({
    //   columns: columnsFilteredOverusedLicenses,
    //   data: filteredO365Licenses ? filteredO365Licenses.filter(license => license.used > license.total)  : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    //   enableColumnOrdering: true,
    //   enableGrouping: true,
    //   enableColumnPinning: true,
    //   enableFacetedValues: true,
    //   // enableRowSelection: true,
    //   initialState: {
    //     density:"compact",
    //     // showColumnFilters: true,
    //     // showGlobalFilter: true,
    //     columnPinning: {
    //       left: ['mrt-row-expand', 'mrt-row-select'],
    //       right: ['mrt-row-actions'],
    //     },
    //     pagination: {
    //       pageSize: 50,

    //     }
    //   },
    //   paginationDisplayMode: 'pages',
    //   positionToolbarAlertBanner: 'bottom',
    //   positionGlobalFilter:"left",
    //   muiSearchTextFieldProps: {
    //     variant: 'outlined',
    //     fullWidth: true,
        
    //   },
    //   muiPaginationProps: {
    //   color: 'secondary',
    //   rowsPerPageOptions: [50, 100, 150],
    //   shape: 'rounded',
    //   variant: 'outlined',
    //   },
    // });

    // const columnsLicenseHistory = useMemo(
    //   () => [
    //     {
    //       id: 'licensesHistory',
    //       columns: [
    //         {
    //           accessorFn: (row) =>
    //             new Date(row.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
    //             ' ' +
    //             new Date(row.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
    //           id: 'date',
    //           header: 'Date',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) =>
    //             row.entityType === "used"
    //               ? "Utilisation"
    //               : row.entityType === "total"
    //               ? "Total"
    //               : row.entityType,
    //           id: 'type',
    //           header: 'Type',
    //           size: 40,
    //         },
    //         {
    //           accessorFn: (row) =>
    //             row.action === "added"
    //               ? "Ajout"
    //               : row.action === "removed"
    //               ? "Suppression"
    //               : row.action,
    //           id: 'action',
    //           header: 'Action',
    //           size: 40,
    //         },
    //         {
    //           accessorKey: 'quantityDiff',
    //           header: 'Différence',
    //           size: 40,
    //           Cell: ({ cell }) => (
    //             <Chip
    //               label={cell.getValue() > 0 ? `+${cell.getValue()}` : cell.getValue()}
    //               color={cell.getValue() > 0 ? "success" : "error"}
    //               size="small"
    //             />
    //           ),
    //         },
    //         {
    //           accessorKey: 'quantityBefore',
    //           header: 'Avant',
    //           size: 40,
    //         },
    //         {
    //           accessorKey: 'quantityAfter',
    //           header: 'Après',
    //           size: 40,
    //         },
    //         {
    //           accessorFn: (row) => row.organizationDetails?.name,
    //           id: 'org',
    //           header: 'Organisation',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) => row.details?.additionalInfo?.licenseName,
    //           id: 'license',
    //           header: 'Licence',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) => row.details?.additionalInfo?.userPrincipalName,
    //           id: 'user',
    //           header: 'Utilisateur',
    //           size: 60,
    //         },
    //       ],
    //     },
    //   ],
    //   [],
    // );
    
  
    // const tableLicenseHistory = useMaterialReactTable({
    //   columns: columnsLicenseHistory,
    //   data: history ? history.filter((item) => item.entitySubType === "o365license" || item.logType?.includes('license'))  : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    //   enableColumnOrdering: true,
    //   enableGrouping: true,
    //   enableColumnPinning: true,
    //   enableFacetedValues: true,
    //   // enableRowSelection: true,
    //   initialState: {
    //     density:"compact",
    //     // showColumnFilters: true,
    //     // showGlobalFilter: true,
    //     columnPinning: {
    //       left: ['mrt-row-expand', 'mrt-row-select'],
    //       right: ['mrt-row-actions'],
    //     },
    //     pagination: {
    //       pageSize: 50,

    //     }
    //   },
    //   paginationDisplayMode: 'pages',
    //   positionToolbarAlertBanner: 'bottom',
    //   positionGlobalFilter:"left",
    //   muiSearchTextFieldProps: {
    //     variant: 'outlined',
    //     fullWidth: true,
        
    //   },
    //   muiPaginationProps: {
    //   color: 'secondary',
    //   rowsPerPageOptions: [50, 100, 150],
    //   shape: 'rounded',
    //   variant: 'outlined',
    //   },
    // });

    // const columnsUserHistory = useMemo(
    //   () => [
    //     {
    //       id: 'userHistory',
    //       columns: [
    //         {
    //           accessorFn: (row) =>
    //             new Date(row.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) +
    //             ' ' +
    //             new Date(row.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
    //           id: 'date',
    //           header: 'Date',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) =>
    //             row.entityType === "used"
    //               ? "Utilisation"
    //               : row.entityType === "total"
    //               ? "Total"
    //               : row.entityType,
    //           id: 'type',
    //           header: 'Type',
    //           size: 40,
    //         },
    //         {
    //           accessorFn: (row) =>
    //             row.action === "added"
    //               ? "Ajout"
    //               : row.action === "removed"
    //               ? "Suppression"
    //               : row.action,
    //           id: 'action',
    //           header: 'Action',
    //           size: 40,
    //         },
    //         {
    //           accessorKey: 'quantityDiff',
    //           header: 'Différence',
    //           size: 40,
    //           Cell: ({ cell }) => (
    //             <Chip
    //               label={cell.getValue() > 0 ? `+${cell.getValue()}` : cell.getValue()}
    //               color={cell.getValue() > 0 ? "success" : "error"}
    //               size="small"
    //             />
    //           ),
    //         },
    //         {
    //           accessorKey: 'quantityBefore',
    //           header: 'Avant',
    //           size: 40,
    //         },
    //         {
    //           accessorKey: 'quantityAfter',
    //           header: 'Après',
    //           size: 40,
    //         },
    //         {
    //           accessorFn: (row) => row.organizationDetails?.name,
    //           id: 'org',
    //           header: 'Organisation',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) => row.details?.additionalInfo?.licenseName,
    //           id: 'license',
    //           header: 'Licence',
    //           size: 60,
    //         },
    //         {
    //           accessorFn: (row) => row.details?.additionalInfo?.userPrincipalName,
    //           id: 'user',
    //           header: 'Utilisateur',
    //           size: 60,
    //         },
    //       ],
    //     },
    //   ],
    //   [],
    // );
    
  
    // const tableUserHistory = useMaterialReactTable({
    //   columns: columnsUserHistory,
    //   data: history ? history.filter((item) => item.entitySubType === "o365user" || item.logType?.includes('usage'))  : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    //   enableColumnOrdering: true,
    //   enableGrouping: true,
    //   enableColumnPinning: true,
    //   enableFacetedValues: true,
    //   // enableRowSelection: true,
    //   initialState: {
    //     density:"compact",
    //     // showColumnFilters: true,
    //     // showGlobalFilter: true,
    //     columnPinning: {
    //       left: ['mrt-row-expand', 'mrt-row-select'],
    //       right: ['mrt-row-actions'],
    //     },
    //     pagination: {
    //       pageSize: 50,

    //     }
    //   },
    //   paginationDisplayMode: 'pages',
    //   positionToolbarAlertBanner: 'bottom',
    //   positionGlobalFilter:"left",
    //   muiSearchTextFieldProps: {
    //     variant: 'outlined',
    //     fullWidth: true,
        
    //   },
    //   muiPaginationProps: {
    //   color: 'secondary',
    //   rowsPerPageOptions: [50, 100, 150],
    //   shape: 'rounded',
    //   variant: 'outlined',
    //   },
    // });










return (
    <Box>
        <PageHeader section="Infrastructure" title="O365" sx={{ my: 1 }} />
        <Grid container spacing={3}>
            <Grid item size={{ xs: 12, lg: 4 }}>
                <StatCard icon={<Avatar sx={{bgcolor:'#d32f2f'}}><KeyIcon/></Avatar>}  bgColor={filteredO365Licenses.filter(license => license.used > license.total).length > 0 && '#ffebee'} borderColor={filteredO365Licenses.filter(license => license.used > license.total).length > 0 && '1px solid #d32f2f'} title={"Licenses surconsommées"} value={filteredO365Licenses.filter(license => license.used > license.total).length} />
            </Grid>
            <Grid item size={{ xs: 12, lg: 4 }}>
                <StatCard icon={<Avatar sx={{bgcolor:'#fbc02d'}}><AccessTimeFilledIcon/></Avatar>} bgColor={expiringSoonCount > 0 && '#fffde7' } borderColor={expiringSoonCount > 0 && '1px solid #fbc02d'} title={"Expirations proches"} value={expiringSoonCount} interval={"Sur les 30 prochains jours"}/>
            </Grid>
           
        </Grid>
        <Grid container spacing={3} sx={{ mt: 4 }}>
            <Grid item size={{ xs: 12, lg: 4 }}>
                {!loadingUser ? (
                    <StatCard icon={<Avatar sx={{bgcolor:'black'}}><PersonIcon/></Avatar>} title={"Nombre total d'utilisateur O365"} value={filteredO365Users.length} />
                ) : (<Skeleton variant='rounded' height={'100%'}/>)}
            </Grid>
            <Grid item size={{ xs: 12, lg: 4 }}>
                {!loadingLicense ? (
                <StatCard icon={<Avatar sx={{bgcolor:'black'}}><KeyIcon/></Avatar>} title={"Nombre total de licences O365"} value={filteredO365Licenses.length} />
                ) : (<Skeleton variant='rounded' height={'100%'}/>)
                }
            </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 4 }}>
            <Grid item size={{ xs: 12, md: 6 }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                Surconsommation de licenses 
            </Typography>
                <Card>
                    
                <Box sx={{ width: '100%' }}>
                    {/* <MaterialReactTable table={tableFilteredOverusedLicenses} /> */}
                    <DataGrid
                        rows={filteredO365Licenses
                            .filter(license => license.used > license.total)
                            .map((license, idx) => ({
                                id: license._id || idx,
                                name: license.licenseName,
                                used: license.used,
                                total: license.total,
                                org: license.organizationName,
                                over: license.used - license.total,
                            }))
                        }
                        columns={[
                            { field: 'name', headerName: 'Nom', flex: 1 },
                            { field: 'used', headerName: 'Utilisé', flex: 1 },
                            { field: 'total', headerName: 'Total', flex: 1 },
                            { field: 'org', headerName: 'Organisation', flex: 1 },
                            {
                                field: 'over',
                                headerName: 'Surutilisation',
                                flex: 1,
                                renderCell: (params) => (
                                    <Chip label={`+${params.value}`} color='error' />
                                )
                            },
                        ]}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                        density='compact'

                    />
                </Box>
            </Card>
            </Grid>
            <Grid item size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Licences expirant dans les 30 jours
            </Typography>
            <Card>
                <Box sx={{ height: 400, width: '100%' }}>
                    <DataGrid
                        rows={filteredO365Licenses
                            .filter(license => {
                                if (!license.nextCycleDateTime) return false;
                                const expDate = new Date(license.nextCycleDateTime);
                                const now = new Date();
                                const diffDays = (expDate - now) / (1000 * 60 * 60 * 24);
                                return diffDays >= 0 && diffDays <= 30;
                            })
                            .map((license, idx) => ({
                                id: license._id || idx,
                                name: license.licenseName,
                                org: license.organizationName,
                                exp: license.nextCycleDateTime
                                    ? new Date(license.nextCycleDateTime).toLocaleDateString('fr-FR')
                                    : '-',
                                used: license.used,
                                total: license.total,
                            }))
                        }
                        columns={[
                            { field: 'name', headerName: 'Nom', flex: 1 },
                            { field: 'org', headerName: 'Organisation', flex: 1 },
                            { field: 'exp', headerName: "Date d'expiration", flex: 1 },
                            { field: 'used', headerName: 'Utilisé', flex: 1 },
                            { field: 'total', headerName: 'Total', flex: 1 },
                        ]}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                        density='compact'

                    />

                </Box>
            </Card>  
            </Grid>

        </Grid>
        <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Historique des licences
            </Typography>
            <Card>
                <Box sx={{ height: 400, width: '100%' }}>
                    {/* <MaterialReactTable table={tableLicenseHistory} /> */}

                    <DataGrid
                        rows={history
                            .filter((item) => item.entitySubType === "o365license" || item.logType?.includes('license'))
                            .map((item, idx) => ({
                                id: item._id || idx,
                                date: new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' +
                                    new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                                type: item.entityType === "used" ? "Utilisation" : item.entityType === "total" ? "Total" : item.entityType,
                                action: item.action === "added" ? "Ajout" : item.action === "removed" ? "Suppression" : item.action,
                                diff: item.quantityDiff,
                                before: item.quantityBefore,
                                after: item.quantityAfter,
                                org: item.organizationDetails?.name,
                                license: item.details?.additionalInfo?.licenseName,
                                user: item.details?.additionalInfo?.userPrincipalName,
                            }))
                        }
                        columns={[
                            { field: 'date', headerName: 'Date', flex: 1 },
                            { field: 'type', headerName: 'Type', flex: 1 },
                            { field: 'action', headerName: 'Action', flex: 1 },
                            {
                                field: 'diff',
                                headerName: 'Différence',
                                flex: 1,
                                renderCell: (params) => (
                                    <Chip
                                        label={params.value > 0 ? `+${params.value}` : params.value}
                                        color={params.value > 0 ? "success" : "error"}
                                        size="small"
                                    />
                                )
                            },
                            { field: 'before', headerName: 'Avant', flex: 1 },
                            { field: 'after', headerName: 'Après', flex: 1 },
                            { field: 'org', headerName: 'Organisation', flex: 1 },
                            { field: 'license', headerName: 'Licence', flex: 1 },
                            { field: 'user', headerName: 'Utilisateur', flex: 1 },
                        ]}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                        density='compact'
                        sx={{
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
          backgroundColor: '#fff',
          color: '#212121',
          border: 'none',
          boxShadow: 1,

          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1F6B43',
            color: 'black',
            fontWeight: 'bold',
          },
          '& .MuiDataGrid-row:nth-of-type(even)': {
            backgroundColor: '#F9F9F9',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#F1F8F4',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid #E0E0E0',
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: '#FAFAFA',
          },
        }}

                    />
                    {/* <MaterialReactTable table={tableLicenseHistory} /> */}

                </Box>
            </Card>
        </Box>
        <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Historique des utilisateurs
            </Typography>
            <Card>
                <Box sx={{ height: 400, width: '100%' }}>
                    {/* <MaterialReactTable table={tableUserHistory} /> */}

                    <DataGrid
                        rows={history
                            .filter((item) => item.entitySubType === "o365user" || item.logType?.includes('usage'))
                            .map((item, idx) => ({
                                id: item._id || idx,
                                date: new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' +
                                    new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                                type: item.entityType === "used" ? "Utilisation" : item.entityType === "total" ? "Total" : item.entityType,
                                action: item.action === "added" ? "Ajout" : item.action === "removed" ? "Suppression" : item.action,
                                diff: item.quantityDiff,
                                before: item.quantityBefore,
                                after: item.quantityAfter,
                                org: item.organizationDetails?.name,
                                license: item.details?.additionalInfo?.licenseName,
                                user: item.details?.additionalInfo?.userPrincipalName,
                            }))
                        }
                        columns={[
                            { field: 'date', headerName: 'Date', flex: 1 },
                            { field: 'type', headerName: 'Type', flex: 1 },
                            { field: 'action', headerName: 'Action', flex: 1 },
                            {
                                field: 'diff',
                                headerName: 'Différence',
                                flex: 1,
                                renderCell: (params) => (
                                    <Chip
                                        label={params.value > 0 ? `+${params.value}` : params.value}
                                        color={params.value > 0 ? "success" : "error"}
                                        size="small"
                                    />
                                )
                            },
                            { field: 'before', headerName: 'Avant', flex: 1 },
                            { field: 'after', headerName: 'Après', flex: 1 },
                            { field: 'org', headerName: 'Organisation', flex: 1 },
                            { field: 'license', headerName: 'Licence', flex: 1 },
                            { field: 'user', headerName: 'Utilisateur', flex: 1 },
                        ]}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        disableSelectionOnClick
                        density='compact'

                    />
                </Box>
            </Card>
        </Box>
    </Box>
);
};

export default O365Dashboard;
